import React from "react"
import Seo from '../components/seo';
import Layout from '../containers/layout/layout'
import Banner from '../containers/blog/banner'
import Blog from '../containers/blog/blog-area'

const BlogPage = () => (
	<Layout>
		<Seo title="Blog" />
		<Banner />
		<Blog />
	</Layout>
)

export default BlogPage